import { render, staticRenderFns } from "./pricePublicity.vue?vue&type=template&id=237a364a&scoped=true"
import script from "./pricePublicity.vue?vue&type=script&lang=js"
export * from "./pricePublicity.vue?vue&type=script&lang=js"
import style0 from "./pricePublicity.vue?vue&type=style&index=0&id=237a364a&prod&scoped=true&lang=less"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "237a364a",
  null
  
)

export default component.exports